<template>
  <header class="app-header d-flex justify-content-between align-items-center">
    <div v-if="env != 'production'" class="badge badge-light env-badge">{{ env }} Server</div>
    <div class="nav-right">
      <div class="user-nav">
        <div class="user-details">
          <span class="username">{{ getUserName }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import router from "@/router";
import { getUser } from "@/middleware/auth";

export default {
  name: "AppHeader",
  data() {
    return {
      user: null,
      env: process.env.NODE_ENV
    };
  },
  computed: {
    getUserName() {
      if (this.user) {
        return this.user.name;
      }
      return "";
    }
  },
  mounted() {
    this.user = getUser();
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/common/_variables.scss";

.app-header {
  position: sticky;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 rem-calc(2) rem-calc(15) rgba($ui-dark, 0.075);
  padding: 0 rem-calc(30);
  height: $header-height;
  z-index: 9999;
  .env-badge {
    text-transform: capitalize;
  }
  .nav-right {
    margin-left: auto;
    margin-right: 0;
    font-weight: $font-weight-semibold;
    .user-nav {
      display: flex;
      align-content: center;
      .avatar {
        width: rem-calc(50);
        height: rem-calc(50);
        border-radius: 50%;
      }
      .user-details {
        text-align: right;
        .username {
          display: block;
          font-size: 1rem;
          font-weight: $font-weight-regular;
        }
        .auth-group {
          display: block;
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.3);
        }
      }
    }
  }
}
// Responsive Overrides

@media (max-width: 1280px) {
  .app-header {
    width: 100%;

    .nav-right {
      margin: 0 0 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue